import Vue from 'vue';
export default Vue.extend({
    name: 'CommonDialogue',
    props: {
        header: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: 'info'
        }
    },
    setup(props) {
        function getIcon() {
            switch (props.type) {
                case 'success':
                    return 'check-circle';
                case 'warning':
                    return 'exclamation-triangle';
                case 'error':
                    return 'exclamation-triangle';
                default:
                    return 'info-circle';
            }
        }
        return { getIcon };
    }
});
